import { css } from 'styled-components';
import { Shadows } from '../../../../play-core/styles/Shadows';
import { Viewports } from '../../../../play-core/styles/Viewports';
export const desktopHeaderHeight = 72;
export const mobileHeaderHeight = 50;
export const headerHeight = css(["min-height:", "px;", "{min-height:", "px;}"], desktopHeaderHeight, Viewports.for('small'), mobileHeaderHeight);
export const headerShadow = Shadows.applySingle(6);